import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import './index.scss';
import { SmallHeroSection } from '../../layouts/SmallHeroSection';
import { Navbar } from '../../layouts/Navbar';
import { PricesSection } from '../../layouts/PricesSection';
import { Footer } from '../../layouts/Footer';


export const PricesPage = () => {

    const location = useLocation();
    const scrollToId = new URLSearchParams(location.search).get('scrollTo');

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [])

    // if the 'scrollTo' query param is present, scroll to the div
    // with that id
    useEffect(() => {
        const targetDiv = document.getElementById(scrollToId);

        if (targetDiv) {
            targetDiv.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
        }
    }, [ scrollToId ]);

	return <div>
		<Navbar />
        <SmallHeroSection 
            titleI18nKey='pricesPage.title'
            subtitleI18nKey='pricesPage.subtitle'
		/>
		<div className='primary-background'>
			<PricesSection />
		</div>
		<Footer />
	</div>
}

export default PricesPage;
